module.exports = __webpack_public_path__ + "img/kai-new2.6acb7c4e.png";